import React from 'react';
import { Button } from '@economic/gaudi';
import { t } from '../../../shared/components/l10n/l10n';
import { PlanInfo } from './shared';

interface Props {
    selectedPlan: PlanInfo;
    onUpgrade: () => void;
    onCancel: () => void;
}

export function ConfirmPlanChangePage({ selectedPlan, onUpgrade, onCancel }: Props) {
    return (
        <div className="form">
            <h1>{t(`SUBSCRIPTIONSTATUS_UPGRADE_CONFIRM_TITLE`, { PLANNAME: selectedPlan.name })}</h1>
            <p>{t`SUBSCRIPTIONSTATUS_UPGRADE_CONFIRM_MESSAGE`}</p>

            <div className="form__buttons">
                <Button onClick={onUpgrade} appearance="primary">{t`SUBSCRIPTIONSTATUS_UPGRADE_CONFIRM_ACCEPT`}</Button>
                <Button onClick={onCancel} appearance="discrete">
                    {t`SUBSCRIPTIONSTATUS_UPGRADE_CONFIRM_CANCEL`}
                </Button>
            </div>
        </div>
    );
}
